import React from 'react';
import PropTypes from 'prop-types';
import { LuArrowRight, LuChevronRight } from 'react-icons/lu';
import Badge from '../../../components/ui/Badge';
import GlassIcon from '../../../components/ui/GlassIcon';

/**
 * One module on the Kalite Yönetimi home: icon, name, what it is for and
 * small badges (e.g. "Profilde görünür"). Opens the module's window.
 * A compact row on phones, a tile from `sm` up.
 */
const ModuleTile = ({ icon: Icon, gradient, title, text, badges = [], openLabel, onOpen }) => (
  <button
    type="button"
    onClick={onOpen}
    className="tw-group tw-flex tw-h-full tw-w-full tw-items-start tw-gap-3.5 tw-rounded-2xl tw-border tw-border-slate-200/80 tw-bg-white/70 tw-p-3.5 tw-text-left tw-transition tw-duration-200 hover:-tw-translate-y-0.5 hover:tw-border-teal-500/40 hover:tw-bg-white hover:tw-shadow-[0_18px_40px_-26px_rgba(15,23,42,0.45)] focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-teal-500/50 sm:tw-flex-col sm:tw-gap-3 sm:tw-p-4 dark:tw-border-white/10 dark:tw-bg-white/[0.03] dark:hover:tw-border-teal-400/40 dark:hover:tw-bg-white/[0.06]"
  >
    <GlassIcon gradient={gradient} size="md">
      <Icon aria-hidden="true" className="tw-h-6 tw-w-6" />
    </GlassIcon>

    <span className="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-gap-1">
      <span className="tw-text-[0.95rem] tw-font-semibold tw-tracking-tight tw-text-slate-900 dark:tw-text-white">{title}</span>
      <span className="tw-text-sm tw-leading-relaxed tw-text-slate-500 dark:tw-text-slate-400">{text}</span>
      {badges.length > 0 && (
        <span className="tw-mt-1.5 tw-flex tw-flex-wrap tw-gap-1.5 sm:tw-mt-auto sm:tw-pt-1.5">
          {badges.map(({ key, tone, icon: BadgeIcon, label }) => (
            <Badge key={key} tone={tone}>
              {BadgeIcon && <BadgeIcon aria-hidden="true" className="tw-h-3 tw-w-3" />}
              {label}
            </Badge>
          ))}
        </span>
      )}
    </span>

    <span className="tw-hidden tw-items-center tw-gap-1.5 tw-text-sm tw-font-semibold tw-text-teal-700 sm:tw-inline-flex dark:tw-text-teal-300">
      {openLabel}
      <LuArrowRight aria-hidden="true" className="tw-h-4 tw-w-4 tw-transition-transform group-hover:tw-translate-x-0.5" />
    </span>
    <LuChevronRight aria-hidden="true" className="tw-mt-3 tw-h-5 tw-w-5 tw-shrink-0 tw-text-slate-400 sm:tw-hidden" />
  </button>
);

ModuleTile.propTypes = {
  icon: PropTypes.elementType.isRequired,
  gradient: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  badges: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      tone: PropTypes.string,
      icon: PropTypes.elementType,
      label: PropTypes.string.isRequired,
    })
  ),
  openLabel: PropTypes.string.isRequired,
  onOpen: PropTypes.func.isRequired,
};

export default ModuleTile;
